import {twMerge} from 'tailwind-merge';
import clsx from 'clsx';

const cn = (...inputs) => {
  return twMerge(clsx(...inputs));
};

export {cn};
